import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react'
import { HEX_COLOR_REGEX } from '../utils'
interface CustomButtonPropTypes
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset'
  variant?: string
  size?: string
  width?: string
  isFilled?: boolean
  children: ReactNode
  widthClass?: string
  color?: 'primary' | 'error' | 'others' | 'cyan' | 'disabled'
  className?: string
  hcpPrimaryColor?: string
  verticalPaddingClasses?: string
  horizontalPaddingClasses?: string
  dataQaId?: string
  customStyles?: object
  height?: string
}

const CustomButton = forwardRef<HTMLButtonElement, CustomButtonPropTypes>(
  (
    {
      dataQaId = '',
      type = 'button',
      isFilled = false,
      color = 'primary',
      widthClass = 'w-fit',
      children,
      className = '',
      hcpPrimaryColor,
      disabled,
      verticalPaddingClasses = '',
      horizontalPaddingClasses = 'px-2.5',
      customStyles = {},
      height = 'h-button-height',
      ...rest
    }: CustomButtonPropTypes,
    ref
  ) => {
    const isHexColor = (color: string | undefined): boolean => {
      return HEX_COLOR_REGEX.test(color ?? '')
    }
    const solidColorClass: { [key: string]: string } = {
      primary: 'bg-primary-500 text-white',
      error: 'bg-error-500 text-white',
      cyan: `text-white`,
      disabled: `bg-accent-100 text-accent-900`,
      others: '',
    }
    const outlinedColorClass: { [key: string]: string } = {
      primary: 'border-primary-500 text-accent-900',
      error: 'border-error-500 text-white',
      disabled: `border-accent-900 text-accent-900`,
      others: '',
    }

    const cyanClass =
      color === 'cyan' && hcpPrimaryColor && !isHexColor(hcpPrimaryColor)
        ? hcpPrimaryColor
        : ''

    return (
      <button
        ref={ref}
        data-qa-id={dataQaId || ''}
        type={type}
        className={`inline-flex items-center justify-center font-primary font-light text-xs rounded truncate ${height} ${verticalPaddingClasses}
      ${isFilled ? '' : 'border'}  
      ${horizontalPaddingClasses} ${widthClass} 
        ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
      ${className}  
      ${
        isFilled
          ? disabled
            ? solidColorClass['disabled']
            : solidColorClass[color]
          : disabled
          ? outlinedColorClass['disabled']
          : outlinedColorClass[color]
      }
       ${cyanClass}
      `}
        {...rest}
        disabled={disabled}
        style={
          color === 'cyan' && hcpPrimaryColor && isHexColor(hcpPrimaryColor)
            ? { backgroundColor: hcpPrimaryColor, ...customStyles }
            : { ...customStyles }
        }
      >
        {children}
      </button>
    )
  }
)

CustomButton.displayName = 'Custom Button'

export default CustomButton
